import React from 'react'
import { useParams } from 'react-router-dom'
import Registrations from './Registrations/Registrations'
import Container from '@mui/material/Container'
function CreateTournament() {
  const { id } = useParams()

  return (
    <Container sx={{ mb: 10 }}>
      <Registrations />
    </Container>
  )
}

export default CreateTournament
